import { useEffect, useState } from "react";
import { Users2 } from "lucide-react";
import ActivitiesShell from "../components/activities/ActivitiesShell";
import AutoImageSlider from "../components/AutoImageSlider";
import { api, formatApiError } from "../lib/api";

export default function Activities() {
  const [stories, setStories] = useState([]);
  const [loadingStories, setLoadingStories] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/activities");
        setStories(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(formatApiError(e));
      } finally {
        setLoadingStories(false);
      }
    };
    load();
  }, []);

  return (
    <ActivitiesShell
      introTitle="A place to see our events, seva and togetherness."
      introSubtitle="Here we share the moments that matter to our forum, from learning sessions and family get-togethers to seva visits and community celebrations."
    >
      <div className="space-y-6">
        <section className="space-y-6">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4">
            <div>
              <div className="overline mb-3">Forum stories</div>
              <h2 className="font-heading text-2xl sm:text-3xl font-light text-ink">
                Latest stories from the council
              </h2>
            </div>
          </div>

          {loadingStories ? (
            <div className="card-premium text-center text-ink-muted">
              Loading stories...
            </div>
          ) : stories.length > 0 ? (
            stories.map((story, index) => (
              <article
                key={story.id}
                className="card-premium overflow-hidden"
                data-testid={`forum-story-${index}`}
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="inline-flex items-center gap-2 rounded-full bg-cream-deep px-3 py-1 text-xs font-medium text-brand-secondary">
                      <Users2 className="h-3.5 w-3.5" />
                      {story.tag || "Forum"}
                    </div>
                    <h3 className="mt-4 font-heading text-2xl sm:text-3xl font-light text-ink">
                      {story.title}
                    </h3>
                    {story.meta ? (
                      <p className="mt-2 text-sm text-ink-muted">{story.meta}</p>
                    ) : null}
                  </div>
                </div>

                <p className="mt-4 text-ink-soft leading-relaxed max-w-3xl whitespace-pre-wrap">
                  {story.body}
                </p>

                {story.gallery_srcs?.length > 0 ? (
                  <AutoImageSlider
                    images={story.gallery_srcs}
                    alt={story.title}
                    className="mt-6 h-64 sm:h-80 md:h-[28rem] w-full rounded-2xl"
                  />
                ) : story.image_src ? (
                  <AutoImageSlider
                    images={[story.image_src]}
                    alt={story.title}
                    className="mt-6 h-64 sm:h-80 md:h-96 w-full rounded-2xl"
                  />
                ) : null}
              </article>
            ))
          ) : (
            <div className="card-premium text-center text-ink-muted">
              No forum stories yet.
            </div>
          )}
        </section>

        <div className="card-premium text-center text-ink-muted">
          No demo activities are loaded right now.
        </div>
      </div>
    </ActivitiesShell>
  );
}
